<div class="calendar-container">
  <app-loader *ngIf="showLoader" style="height: 100%;"></app-loader>
  <div class="calendar-header">
    <button class="calendar-button" id="previous-month" (click)="goToPreviousMonth()">&#8592;</button>
    <span>{{ getMonthName() }} {{ displayedYear }}</span>
    <button class="calendar-button" id="next-month" (click)="goToNextMonth()">&#8594;</button>
  </div>
  <div id="calendar-body"></div>
</div>